import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { localize } from 'vee-validate';
import sv from 'vee-validate/dist/locale/sv.json';
import nb from 'vee-validate/dist/locale/nb_NO.json';

localize({
  sv,
  nb
});

localize('sv');

extend('required', required);

export function setValidationLocale(code) {
  localize(code);
}